import Flying from './flying';
import Rect from './rect';
import * as Types from './types';

export default Flying;
export { Flying, Rect, Types };